import { createContext, useContext } from 'react';

export const DashboardLayoutContext = createContext({
  isNavOpen: true,
});

export const useDashboardLayout = () => useContext(DashboardLayoutContext);
